module.exports = __webpack_public_path__ + "bin/6a3b24fb5c4e6897c5774f175622ccfa.png";